// extracted by mini-css-extract-plugin
export default {"cardOrder3":"order-info_cardOrder3__Oveiz","cardOrder2":"order-info_cardOrder2__T3tgc","header":"order-info_header__-bvsY"};